import styled from 'styled-components';
import ExplainabilityInfoMenu from '../explainability-info-menu.component';

export const Container = styled(ExplainabilityInfoMenu)`
  background-image: linear-gradient(to bottom, rgba(52, 204, 102, 0.05), rgba(52, 204, 102, 0));
`;
